export default ({router, store}) => {
  router.beforeEach(async (to, from, next) => {
    // -- allow any auth route without login
    const reLogin = /\/auth/
    if (reLogin.test(to.path)) {
      return next()
    }

    // -- if route requires auth
    const routeAuth = to.meta && to.meta.auth ? to.meta.auth : []

    // -- route requires no auth
    if (!routeAuth || (Array.isArray(routeAuth) && !routeAuth.length)) {
      return next()
    } else {
      if (store.getters['auth/hasAnyRole'](routeAuth)) {
        return next()
      } else {
        return next({
          path: '/auth/login'
        })
      }
    }
  })
}
